/* eslint-disable jsx-a11y/img-redundant-alt */
import { useState } from 'react';
import errorImage from '../../../Images/uyLogo.png';

export function ImageWithFallback(props) {
	const [didError, setDidError] = useState(false);

	const handleError = () => {
		setDidError(true);
	};

	const { src, alt, style, className, ...rest } = props;

	return didError ? (
		<div
			className={`inline-block bg-gray-100 text-center align-middle ${className ?? ''}`}
			style={style}
		>
			<div className='flex items-center justify-center w-full h-full'>
				<img src={errorImage} alt='Error loading image' {...rest} data-original-url={src} />
			</div>
		</div>
	) : (
		<img src={src} alt={alt} className={className} style={style} {...rest} onError={handleError} />
	);
}
